exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-2cbc9d7a]{width:100%;clear:both;margin-top:50px;border-top:1px solid hsla(0,0%,100%,.1);padding:15px 30px}.footer__socials[data-v-2cbc9d7a]{text-align:left}.footer__socials a img[data-v-2cbc9d7a]{opacity:.2;transition:all .2s ease;margin-right:13px}.footer__socials a:hover img[data-v-2cbc9d7a]{opacity:.9}.footer__links[data-v-2cbc9d7a]{text-align:right}.footer__links a[data-v-2cbc9d7a]{opacity:.2;transition:all .2s ease;margin-left:20px}.footer__links a[data-v-2cbc9d7a]:hover{opacity:.9}", ""]);

// exports
